import type { IndustryTransitionImpactReport } from "../types/impactReport";

export const toVisibleImpactReport = (report: IndustryTransitionImpactReport): IndustryTransitionImpactReport => {
    const sections = report.sections.filter((section) => section.assets.length > 0);

    return {
        ...report,
        sections,
        totalAssetCount: sections.reduce((total, section) => total + section.assets.length, 0),
    };
};
